module.exports = __webpack_public_path__ + "img/photo-0074.c8dc63dd.jpg";